import styled from 'styled-components';
import TextArea from '../TextArea/TextArea';

export const StyledTextArea = styled(TextArea)`
  overflow: hidden;
  resize: vertical;
  margin-top: 8px;
  padding: 8px;
`;
